<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>Content</span></p>
<table cellpadding="3" cellspacing="3" width="100%">
<tbody><tr>
<td style="width:25%" valign="top"></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/Acknowledgements" title="Link target outside of Sample"><span class="smallcaps">Ackowledgements</span></span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a"></p></td>
<td style="width:75%" valign="top"><p class="left-b1"><span href="#/xhtml/frontmatter1" title="Link target outside of Sample"><span class="smallcaps">Preface to the Second Edition</span></span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a"><a href="#/xhtml/chapter01">One</a></p></td>
<td style="width:75%" valign="top"><p class="left-b"><a href="#/xhtml/chapter01">Understanding as Translation</a></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Two</span></p></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/chapter02" title="Link target outside of Sample">Language and Gnosis</span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Three</span></p></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Word against Object</span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Four</span></p></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/chapter04" title="Link target outside of Sample">The Claims of Theory</span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Five</span></p></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/chapter05" title="Link target outside of Sample">The Hermeneutic Motion</span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Six</span></p></td>
<td style="width:75%" valign="top"><p class="left-b1"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Topologies of Culture</span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"><p class="left-a1"></p></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/Afterword" title="Link target outside of Sample"><span class="smallcaps">Afterward</span></span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/Bibliography" title="Link target outside of Sample"><span class="smallcaps">Select Bibliography</span></span></p></td>
</tr>
<tr>
<td style="width:25%" valign="top"></td>
<td style="width:75%" valign="top"><p class="left-b"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="smallcaps">Index of Proper Names and Titles</span></span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?6fbf1611